import React, { useEffect, useRef } from 'react';
import * as Sentry from "@sentry/react";

import { Spinner, Pane, Text, Dialog, Button, FolderOpenIcon, FolderCloseIcon, TextInput, EditIcon, IconButton, FolderNewIcon, CloudUploadIcon, Tooltip, DownloadIcon, AnnotationIcon, Textarea, RemoveIcon, DeleteIcon, toaster, ShoppingCartIcon, MultiSelectIcon, } from 'evergreen-ui';
import { ErrorBoundary } from '../Misc';
import { DeleteDialog } from '../Misc/DeleteDialog';
import { NewFolderDialog } from './NewFolderDialog';
import { deleteFile } from '../Api/Library/index.ts';
import { useAPI } from "../Api"

import { Book } from './Book';
import { useLibrary } from '../Api/Library/Provider';
import MultipleItemsDialog from './MultipleItemsDialog';



export let ToolButton = (props) => <Pane
    elevation={props.elevation || (props.selected ? 3 : 1)}
    width={props.width || "30%"}
    height={props.height || 30}
    margin={4}
    alignItems="center"
    justifyContent="center"
    display="flex"
    background='white'
>{props.children}</Pane>

export function FolderList({
    library, folder, selectedFolder, open, onAddNewOrder,
    selectFolder, deleteFolder, newFolder,
    elevation = null, readonly }) {
    let Library = useLibrary()

    let selected = selectedFolder && (selectedFolder.key == folder.key);
    const [value, setValue] = React.useState(folder.filename);
    const [evalue, setEValue] = React.useState(folder.filename);
    const [editing, setEditing] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    const handleDragOver = (e) => {
        if (e.dataTransfer.types.indexOf("book") >= 0) {
            e.preventDefault();
            e.target.classList.add("drop-zone");
        }
    }

    const handleDrop = (e, folder) => {
        if (e.dataTransfer.types.indexOf("book") >= 0) {
            e.preventDefault();
            e.stopPropagation();
            const key = e.dataTransfer.getData('book');
            const book = Library.items[Library.indexOf(key)];
            Library.move(folder, book);
        }

        if (e.dataTransfer.types.indexOf("folder") >= 0) {
            e.preventDefault();
            e.stopPropagation();

            const key = e.dataTransfer.getData('folder');
            const dragfolder = Library.items[Library.indexOf(key)];
            let newpath = folder.path();
            // console.log("New Path: ", newpath, "Drag Folder: ", dragfolder);

            // if (newpath.length == 0) {
            //     toaster.danger("Error: Folder Already in Selected Parent");
            //     e.target.classList.remove("drop-zone");
            //     return;
            // }

            if (newpath[0] == dragfolder.filename) {
                toaster.danger("Error: Cannot Move Folder Into Itself");
                e.target.classList.remove("drop-zone");
                return;
            }

            document.getElementById('folderParent').classList.toggle('busy', true)
            newpath.push(dragfolder.filename)
            Library.renameFolder(dragfolder, newpath).then(async (r) => {
                await Library.reloadLibrary()
                document.getElementById('folderParent').classList.toggle('busy', false)
            });
        }

        e.target.classList.remove("drop-zone");

    }

    useEffect(() => {

        if (!editing && (folder.filename != evalue)) {
            let newpath = folder.path();
            newpath[newpath.length - 1] = evalue;

            setSaving(true);
            Library.renameFolder(folder, newpath).then((r) => {
                setSaving(false);
                folder.filename = r;
                setValue(r);
            });
        }
        if (editing) {
            setEValue(value);
        }
    }, [editing]);


    if (selectedFolder && selectedFolder.length) {
        console.error('Selected folder seems to be a Array', selectedFolder);
        return <b>Selected folder seems to be a Array</b>;
    }

    if (!selectedFolder) {
        return <Text>No folder Selected</Text>;
    }

    if (selectedFolder.type != 'folder') {
        return <b>Selected folder seems to be a file {selectedFolder.filename}</b>;
    }

    const handleDrag = (e) => {
        if (e.type == "dragover") {
            if (e.dataTransfer.types.indexOf("Files") < 0) {
                e.preventDefault();
                e.target.classList.add("drop-zone");
            }
            return false;
        }

        if (e.type == "drop") {
            e.target.classList.remove("drop-zone");
        }

        if (e.type == "dragleave") {
            e.target.classList.remove("drop-zone");
        }
    }

    return <Pane>
        <Pane
            flex={1} display="flex"
            height={30}
            draggable={"true"}
            onDragLeave={(e) => { handleDrag(e) }}
            onDrop={(e) => { handleDrag(e) }}
            onDragOver={(e) => { handleDrag(e) }}
            onDragStart={(e) => {
                e.dataTransfer.setData("folder", folder.key);
            }}>
            {selected && editing && <TextInput onFocus={(e) => e.target.select()} flex={1} autoFocus onChange={(e) => { setEValue(e.target.value); }} value={evalue} />}
            {(!selected || (selected && !editing)) &&
                <Button
                    className="folderParent"
                    height={32}
                    display="flex"
                    justifyContent="left"
                    flex={1}
                    onClick={() => { selectFolder(folder); }}
                    onDragOver={(e) => { handleDragOver(e, folder); }}
                    onDrop={(e) => { handleDrop(e, folder); }}
                    onDragLeave={(e) => { e.target.classList.remove("drop-zone") }}

                >
                    {saving && <Spinner size={20} marginRight={8} />}
                    {!saving && open && <FolderOpenIcon size={20} marginRight={8} />}
                    {!saving && !open && <FolderCloseIcon size={20} marginRight={8} />}
                    {value} {saving && <> to {evalue}</>}
                </Button>}

        </Pane>
        <Pane
            elevation={elevation || (open ? 3 : 1)}
            width={'96%'}
            marginBottom={selected ? 8 : 4}
            marginLeft='2%'
            display="flex"
            flexDirection='column'
            padding={open ? 8 : 0}
            background={selected ? '#EBF0FF' : 'white'}

        >

            {selected && <Pane flex={1} display="flex" textAlign='center'>
                <ToolButton><NewFolderDialog
                    onNew={(name) => { newFolder(name); }} /></ToolButton>
                {!readonly &&
                    <ToolButton><Button isLoading={saving} width="100%" padding={0} onClick={() => { setEditing(!editing); }}>{!editing ? <EditIcon size={20} /> : 'Rename'}</Button></ToolButton>}
                {!readonly &&
                    <ToolButton><DeleteDialog width="100%" onDelete={() => { deleteFolder(folder); }} named={'Folder: ' + folder.filename} /></ToolButton>}
            </Pane>}

            {open && library.filter((v) => v.type == 'folder')
                .filter((v) => v.folder && folder.key == v.folder.key)
                .map((b) =>
                    <FolderList
                        key={b.key}
                        folder={b}
                        library={library}
                        open={selectedFolder.isParent(b.key)}
                        selectedFolder={selectedFolder}
                        selectFolder={selectFolder}
                        deleteFolder={deleteFolder}
                        newFolder={newFolder}
                        onAddNewOrder={onAddNewOrder} />
                )}

        </Pane>
    </Pane>;
}


export function Folder(props) {
    const [multipleAddBTN, setMultipleAddBTN] = React.useState("none");
    const [isShown, setIsShown] = React.useState(false)
    const [selected, setSelected] = React.useState([])
    const Library = useLibrary();

    // Use the useMemo hook to memoize the filtered library items
    const filteredLibrary = React.useMemo(() => {
        return props.library.filter((v) => v.type === 'file')
            .filter((v) => v.folder && props.folder.key === v.folder.key);
    }, [props.library, props.folder.key]);


    React.useEffect(() => {
        setSelected([])
    }, [props.library, props.folder.key])


    // const checkSelectedCount = () => {
    //     setTimeout(() => {
    //         const count = document.getElementsByClassName("selected").length;
    //         count > 0 ? setMultipleAddBTN("") : setMultipleAddBTN("none");
    //     }, 100);
    // }

    const selectAll = () => {
        setSelected([...filteredLibrary]);
    }

    const clearSelected = () => {
        setSelected([]);
    }

    const deleteSelected = () => {
        if (selected.length < 1) {
            return toaster.danger("There are no selected items to delete");
        }
        Library.remove([...selected]);
    }

    React.useEffect(() => {

    }, [selected])


    return (
        <ErrorBoundary>
            <Pane display="flex" justifyContent="center" flexDirection={"column"} alignItems="center" overflowY={"scroll"}>
                <Pane display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="95%">
                    {selected.length > 0 && <Button appearance="primary" intent="success" onClick={() => { setIsShown(true); }}>
                        <Pane display="flex" justifyContent="center" alignItems="center" flexDirection="row" gap="5px">
                            <ShoppingCartIcon />
                            <Text color="white">Add {selected.length} Item{selected.length <= 1 ? '' : 's'} to Cart</Text>
                        </Pane>
                    </Button>}
                    <Pane display="flex" gap="10px" width="100%" justifyContent="end" alignItems="center">
                        <Button gap="10px" appearance='primary' intent="success" onClick={() => { selectAll() }}><MultiSelectIcon /> Select All</Button>
                        <Button gap="10px" appearance='primary' onClick={() => { clearSelected() }}><RemoveIcon /> Clear Selected</Button>
                        <DeleteDialog button={true} onDelete={() => deleteSelected()} named="collection of selected files" />
                    </Pane>
                </Pane>
                <Pane display="flex" flexDirection="row" overflowX="auto" flexWrap="wrap" justifyContent="center" flexShrink={"5"}>
                    {filteredLibrary.map((b) => (
                        <Book
                            fileName={b.display}
                            library={props.library}
                            book={b}
                            key={b.key}
                            onClick={(event) => {
                                if (event && event.ctrlKey) {
                                    if (selected.indexOf(b)<0) { setSelected([b, ...selected]) } else {
                                        setSelected(selected.filter(v => v != b));
                                    }
                                } else {
                                    console.log("ELSE")
                                    props.onClick(b);
                                }
                            }}
                            onChecked={(v) => {
                                if (v) { setSelected([b, ...selected]) } else {
                                    setSelected(selected.filter(v => v != b));
                                }
                            }}
                            checked={selected.indexOf(b) >= 0}
                        />
                    ))}
                </Pane>
                {isShown && <MultipleItemsDialog selected={selected} setIsShown={setIsShown} />}
            </Pane>
        </ErrorBoundary>
    );
}